/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Besonderepersonengruppe1Inputs */



/**

* @param {_Field_Besonderepersonengruppe1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_besonderepersonengruppe1 = /** @type {((inputs?: _Field_Besonderepersonengruppe1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Besonderepersonengruppe1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Besondere Personengruppe")
});
export { _field_besonderepersonengruppe1 as "_field_besonderePersonengruppe" }